var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg500Page({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 164,
    viewBox: "0 0 227 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.313 53.6515L177.521 39.9309L78.5635 75.477C78.4757 75.5349 78.388 75.5928 78.3003 75.6507C67.6851 82.6557 73.8261 98.0552 92.0737 110.097C110.233 122.081 133.657 126.191 144.272 119.186C144.36 119.128 144.448 119.07 144.535 119.012L198.313 53.6515Z",
    fill: "#F5FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.313 53.6515C194.979 55.8514 187.61 54.5778 181.908 50.8147C176.205 47.0517 174.275 42.1887 177.609 39.9888C180.943 37.7889 188.312 39.0625 194.014 42.8256C199.629 46.6465 201.647 51.4515 198.313 53.6515Z",
    fill: "#F5FAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.448 118.955L155.15 105.987C154.975 106.102 154.8 106.218 154.624 106.334C145.5 112.355 125.323 108.881 109.532 98.4605C93.8283 88.0977 88.4768 74.7245 97.6006 68.7036C97.776 68.5878 97.9515 68.4721 98.1269 68.3563L78.4758 75.4192C78.388 75.4771 78.3003 75.535 78.2126 75.5928C67.5974 82.5979 73.7385 97.9973 91.986 110.039C110.146 122.023 133.569 126.133 144.184 119.128C144.272 119.07 144.36 119.012 144.448 118.955Z",
    fill: "#F5FAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.732 79.819C176.644 79.8769 176.556 79.9348 176.381 80.0506C170.152 84.1609 156.379 81.7874 145.588 74.6665C134.885 67.6036 131.201 58.4566 137.429 54.3462C137.517 54.2883 137.692 54.1725 137.78 54.1146L117.778 61.2933C117.603 61.4091 117.515 61.467 117.427 61.5249C109.707 66.6194 114.181 77.7928 127.428 86.5346C140.675 95.2764 157.607 98.2289 165.327 93.1343C165.415 93.0764 165.502 93.0185 165.59 92.9606L176.732 79.819Z",
    fill: "#F5FAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.313 53.6515C194.891 55.9093 187.61 54.5778 181.908 50.8147C176.205 47.0517 174.275 42.1887 177.609 39.9888L157.695 47.1096C157.607 47.1675 157.607 47.1675 157.519 47.2254C152.694 50.4095 155.501 57.3566 163.748 62.7985C171.994 68.2404 182.522 70.093 187.347 66.9089C187.347 66.9089 187.435 66.851 187.522 66.7931L198.313 53.6515Z",
    fill: "#F5FAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.734 52.262C194.365 53.8251 188.487 52.6094 183.838 49.5411C179.1 46.4149 177.258 42.6519 179.714 41.0309C182.083 39.4678 187.961 40.6835 192.611 43.7518C197.26 46.8201 199.19 50.641 196.734 52.262Z",
    fill: "#F5FAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.734 52.262C194.365 53.8251 188.487 52.6094 183.838 49.5411C179.1 46.4149 177.258 42.6519 179.714 41.0309C182.083 39.4678 187.961 40.6835 192.611 43.7518C197.26 46.8201 199.19 50.641 196.734 52.262Z",
    fill: "#F5FAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.844 118.392V116.471H0.155912V120.073C-0.684601 126.557 2.79751 132.921 10.7223 137.604L43.9827 156.816C59.8323 165.941 87.6893 164.861 106.061 154.294L129.835 140.606C140.762 134.122 145.805 125.957 144.844 118.392Z",
    fill: "#E7ECF0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9826 153.814L10.7223 134.602C-5.12739 125.477 -3.2062 109.387 15.165 98.8203L38.9395 85.1319C57.3107 74.5655 85.0477 73.3647 101.017 82.6104L134.278 101.822C150.127 110.948 148.206 127.038 129.835 137.604L106.06 151.292C87.6892 161.859 59.9523 162.939 43.9826 153.814Z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0889 8.28503H58.6315L27.7727 112.869C27.7727 112.989 27.7727 113.109 27.7727 113.229C27.7727 127.758 47.945 139.525 72.9202 139.525C97.7754 139.525 118.068 127.758 118.068 113.229C118.068 113.109 118.068 112.989 118.068 112.869L87.0889 8.28503Z",
    fill: "#F5FAFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0889 8.28505C87.0889 12.8478 80.725 16.5701 72.9202 16.5701C65.1155 16.5701 58.7516 12.8478 58.7516 8.28505C58.7516 3.72226 65.1155 0 72.9202 0C80.725 0.120073 87.0889 3.72226 87.0889 8.28505Z",
    fill: "#F5FAFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.948 112.869L111.824 92.0962C111.824 92.3364 111.824 92.5765 111.824 92.8167C111.824 105.304 94.4133 115.51 72.8001 115.51C51.307 115.51 33.7763 105.304 33.7763 92.8167C33.7763 92.5765 33.7763 92.3364 33.7763 92.0962L27.6526 112.869C27.6526 112.989 27.6526 113.109 27.6526 113.229C27.6526 127.758 47.8249 139.525 72.8001 139.525C97.6553 139.525 117.948 127.758 117.948 113.229C117.948 113.109 117.948 112.989 117.948 112.869Z",
    fill: "url(#paint0_linear_7201_126913)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4564 50.1906C99.4564 50.3107 99.4564 50.4308 99.4564 50.6709C99.4564 59.1961 87.5691 66.1604 72.8001 66.1604C58.1512 66.1604 46.1438 59.1961 46.1438 50.6709C46.1438 50.5508 46.1438 50.3107 46.1438 50.1906L39.9 71.3235C39.9 71.5637 39.9 71.6837 39.9 71.8038C39.9 82.3702 54.549 90.8955 72.68 90.8955C90.8111 90.8955 105.46 82.3702 105.46 71.8038C105.46 71.6837 105.46 71.5637 105.46 71.4436L99.4564 50.1906Z",
    fill: "url(#paint1_linear_7201_126913)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0888 8.28503C87.0888 12.9679 80.7249 16.5701 72.9201 16.5701C65.1154 16.5701 58.7515 12.8478 58.7515 8.28503L52.5077 29.2979C52.5077 29.4179 52.5077 29.4179 52.5077 29.538C52.5077 36.142 61.6333 41.4253 72.9201 41.4253C84.207 41.4253 93.3326 36.142 93.3326 29.538C93.3326 29.538 93.3326 29.4179 93.3326 29.2979L87.0888 8.28503Z",
    fill: "url(#paint2_linear_7201_126913)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5674 7.92481C84.5674 11.1668 79.2842 13.9285 72.9203 13.9285C66.4363 13.9285 61.2732 11.2869 61.2732 7.92481C61.2732 4.68283 66.5564 1.92114 72.9203 1.92114C79.2842 1.92114 84.5674 4.56275 84.5674 7.92481Z",
    fill: "url(#paint3_linear_7201_126913)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5674 7.92481C84.5674 11.1668 79.2842 13.9285 72.9203 13.9285C66.4363 13.9285 61.2732 11.2869 61.2732 7.92481C61.2732 4.68283 66.5564 1.92114 72.9203 1.92114C79.2842 1.92114 84.5674 4.56275 84.5674 7.92481Z",
    fill: "#D7DCE1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7201_126913",
    x1: 117.948,
    y1: 92.0962,
    x2: 78.8965,
    y2: 166.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514718,
    stopColor: "#92DD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DE9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7201_126913",
    x1: 105.46,
    y1: 50.1906,
    x2: 68.978,
    y2: 108.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514718,
    stopColor: "#92DD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DE9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7201_126913",
    x1: 93.3326,
    y1: 8.28503,
    x2: 60.9002,
    y2: 48.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514718,
    stopColor: "#92DD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DE9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7201_126913",
    x1: 84.238,
    y1: 7.86885,
    x2: 58.3859,
    y2: 7.86885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353535,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1641,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4123,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    stopColor: "#DC48C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500Page);
export default __webpack_public_path__ + "static/media/500_page.977e524637a816506bd710ed166b326b.svg";
export { ForwardRef as ReactComponent };